module.exports = __webpack_public_path__ + "850a4fbc7b093ca4d480f0202e6a566f.png";